<div [ngClass]="{ 'show': loading }" class="full-screen">

  <!-- =========================================
       LOADER GENERAL
       ========================================= -->
  <ng-container *ngIf="mode === 'default'">

    <div class="shell-loader">

      <!-- Anillos -->
      <div class="ring ring-1"></div>
      <div class="ring ring-2"></div>

      <!-- Puntos orbitando -->
      <div class="orbit orbit-1"></div>
      <div class="orbit orbit-2"></div>
      <div class="orbit orbit-3"></div>

      <!-- Logo -->
      <img
        src="assets/img/logo/logo-bg-none.png"
        alt="Shell"
        class="shell-loading-logo"
      />

    </div>

  </ng-container>


  <!-- =========================================
       LOADER PDF
       ========================================= -->
  <ng-container *ngIf="mode === 'pdf'">

    <div class="pdf-loader">

      <i class="pi pi-file-pdf pdf-icon"></i>

      <div class="pdf-text">
        Generando PDF...
      </div>

      <div class="pdf-bar">
        <div class="pdf-progress"></div>
      </div>

    </div>

  </ng-container>

</div>

<p-toast position="bottom-center"></p-toast>
